import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "../../lib/brand";

const LINKS = [
  { label: "WHAT WE DO", id: "what-we-do", testid: "nav-link-what-we-do" },
  { label: "OUR WORK", id: "our-work", testid: "nav-link-our-work" },
  { label: "CONTACT", id: "inquiry", testid: "nav-link-contact" },
];

export const Nav = () => {
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        solid
          ? "bg-[#0a0a0a]/[0.94] backdrop-blur-md border-b border-[#2a2a2a]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex h-[60px] max-w-[1600px] items-center justify-between px-5 sm:px-8">
        <button
          data-testid="nav-brand-mark"
          onClick={() => go("top")}
          aria-label="No Glyph Studios — back to top"
          className="group flex items-center gap-2.5"
        >
          <span
            className="block h-3 w-3 transition-transform duration-500 group-hover:rotate-90"
            style={{ background: "var(--ng-red)" }}
          />
          <span className="label-mono text-neutral-400 transition-colors group-hover:text-white">
            NGS
          </span>
        </button>

        <div className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => go(l.id)}
              className="link-swipe label-mono text-neutral-400 transition-colors hover:text-white"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-start-a-project"
            onClick={() => go("inquiry")}
            className="label-mono px-5 py-2.5 font-bold text-white transition-transform duration-300 hover:-translate-y-0.5"
            style={{ background: "var(--ng-red)" }}
          >
            START A PROJECT
          </button>
        </div>

        <div className="flex items-center gap-3 lg:hidden">
          <button
            data-testid="nav-start-a-project-mobile"
            onClick={() => go("inquiry")}
            className="label-mono px-3.5 py-2 font-bold text-white"
            style={{ background: "var(--ng-red)" }}
          >
            START
          </button>
          <button
            data-testid="nav-menu-toggle"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="p-1.5 text-neutral-300"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </nav>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="border-t border-[#2a2a2a] bg-[#0a0a0a] lg:hidden"
        >
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`${l.testid}-mobile`}
              onClick={() => go(l.id)}
              className="block w-full border-b border-[#191919] px-6 py-4 text-left font-display text-2xl font-extrabold uppercase tracking-tight text-neutral-200"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
